module.exports = __webpack_public_path__ + "img/mago-meet.423736bb.png";